import * as React from 'react';
import { withRouter } from 'react-router-dom';

import { IScrollToTopProps } from './types';

class ScrollToTopComponent extends React.Component<IScrollToTopProps> {

	componentDidUpdate(prevProps: IScrollToTopProps) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			window.scrollTo(0, 0);
		}
	}

	render(): null {
		return null;
	}

}

export const ScrollToTop = withRouter(ScrollToTopComponent);
